module.exports = __webpack_public_path__ + "static/media/Sensitive-item.6abf7e7b.png";